import { render } from "./OrderProductPrice.vue?vue&type=template&id=2e43e5c6&scoped=true&ts=true"
import script from "./OrderProductPrice.vue?vue&type=script&lang=ts"
export * from "./OrderProductPrice.vue?vue&type=script&lang=ts"

import "./OrderProductPrice.vue?vue&type=style&index=0&id=2e43e5c6&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e43e5c6"]])

export default __exports__